import { Observable } from 'rxjs';
import {HttpResponse} from '@angular/common/http'
import {Injectable} from "@angular/core";
import {ApiService} from "../../../services/api.service";
import {UserDto} from "../../../models/user-dto"
import {FundingGoalDto} from "../../../models/funding-goal-dto";
import {ConsultantDto} from "../../../models/consultant-dto";

//protected/users
//protected/subscriptions
//protected/savedsearches

@Injectable()
export class UserService {

  contextApi = '/api';
  constructor(private apiService: ApiService) {}

  private addImpersonatedEmailToApiUrl(apiUrl: string, impersonatedEmail: string | undefined): string {
    if (impersonatedEmail) {
      apiUrl = apiUrl + '&impersonatedEmail=' + impersonatedEmail;
    }
    return apiUrl;
  }
  public getUserProfile(username: string): any {
    console.log('getUserProfile: username: ' + username);
    return this.apiService.getCall(
      this.contextApi + '/protected/users/read/users/' + username,
      false,
      true,
      {loggedInUsername: username},
      null,
      false,
      null
    );
  }
  public createUserProfileV3(userDto: UserDto): any {
    return this.apiService.postCall(
      this.contextApi + '/public/users/register/v3',
      userDto,
      false,
      false,
      true
    );
  }

  public getConsultantProfileV3(consultantEmail: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/consultants/read/consultants',
      false,
      true,
      {
        targetEmail: consultantEmail,
        loggedInUsername: consultantEmail
      },
      true
    );
  }

  public createConsultantProfileV3(consultantDto: ConsultantDto): any {
    return this.apiService.postCall(
      this.contextApi + '/public/consultants/register/v3',
      consultantDto,
      false,
      false,
      true
    );
  }

  public createConsultantUserV3(consultantUserDto: any): any {
    return this.apiService.postCall(
      this.contextApi + '/public/consultants/users/register/v3',
      consultantUserDto,
      false,
      false,
      true
    );
  }

  public editConsultantUserV3(consultantUserDto: any, loggedInUsername: string): any {
    return this.apiService.putCall(
      this.contextApi + '/protected/consultants/users/edit/v3?loggedInUsername=' + loggedInUsername,
      consultantUserDto,
      false,
      true,
      true
    );
  }

  public getConsultantUserV3(username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/consultants/read/users',
      false,
      true,
      {loggedInUsername: username},
      null,
      false,
      null
    );
  }

  public getApprovedConsultantsDropdown(loggedInUsername: string, impersonatedEmail: any): any {
    let apiUrl: string = this.contextApi + '/protected/consultants/approved/dropdown/all?loggedInUsername=' + loggedInUsername;
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.getCall(
      apiUrl,
      false,
      true,
      null,
      null,
      false,
      null
    );
  }

  public getAllUsersAssociatedWithConsultant(username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/consultants/associated/users/all',
      false,
      true,
      {
        loggedInUsername: username
      },
      null,
      false,
      null
    );
  }

  public getConsultantRoles(): any {
    return this.apiService.getCall(
      this.contextApi + '/public/consultants/users/roles',
      false,
      false,
      null,
      null,
      false,
      null
    );
  }

  public verifyConsultantReferralCodeFlag(consultantId: number, loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/consultants/verify/referral-code/flag',
      false,
      false,
      {
        consultantId: consultantId,
        loggedInUsername: loggedInUsername
      },
      null,
      false,
      null
    );
  }

  public inviteConsultantToCollaborate(consultantEmail: string, consultantRoleName: string,
                                       loggedInUsername: string): any {
    return this.apiService.postCall(
      this.contextApi + '/protected/consultants/email/invite?loggedInUsername=' + loggedInUsername,
      {
        consultantEmail: consultantEmail,
        consultantRoleName: consultantRoleName
      },
      false,
      true,
      true
    );
  }

  public verifyConsultantReferralCodeAtRegistration(consultantEmail: string, referralCode: string): any {
    return this.apiService.getCall(
      this.contextApi + '/public/consultants/register/verify/referral-code',
      false,
      false,
      {
        consultantEmail: consultantEmail,
        referralCode: referralCode
      },
      true
    );
  }

  public removeConsultantFromUser(username: string): any {
    return this.apiService.putCall(
      this.contextApi + '/protected/consultants/remove?loggedInUsername=' + username,
      null,
      false,
      true,
      true
    );
  }

  public verifyEmailCode(username: string, emailVerificationCode: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/users/emails/verify?loggedInUsername=' + username,
      false,
      true,
      {
        emailVerificationCode: emailVerificationCode
      }
    );
  }

  public resendEmailCode(username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/users/emails/resend-code?loggedInUsername=' + username,
      false,
      true,
      {}
    );
  }

  public updateConsultantRole(consultantEmail: string, consultantRoleName: string, username: string): any {
    return this.apiService.putCall(
      this.contextApi + '/protected/consultants/update/role?loggedInUsername=' + username,
      {
        consultantEmail: consultantEmail,
        consultantRoleName: consultantRoleName
      },
      false,
      true,
      true
    );
  }

  public updateUserProfile(userDto: UserDto): any {
    return this.apiService.putCall(
      this.contextApi + '/protected/users/update/users?loggedInUsername=' + userDto.username,
      userDto,
      false,
      true,
      true
    );
  }
  public getTermsAndConditionsLegalDocument(): any {
    return this.apiService.getCall(
      this.contextApi + '/public/legal-agreements/terms-and-conditions',
      false,
      false,
      null,
      null,
      false,
      null
    );
  }
  public createUserTermsAndConditionsLegalAgreement(loggedInUsername: string): any {
    return this.apiService.postCall(
      this.contextApi + '/public/legal-agreements/terms-and-conditions/agree?loggedInUsername=' + loggedInUsername,
      false,
      false, //true
      false
    );
  }

  public changePasswordV2(
    userId: string,
    username: string,
    currentPassword: string,
    newPassword: string,
    newPasswordRepeated: string
  ): any {
    return this.apiService.putCall(
      this.contextApi + '/protected/users/update/users/'+userId+'/change-password/v2?loggedInUsername='+username,
      {
        currentPassword: currentPassword,
        newPassword: newPassword,
        newPasswordRepeated: newPasswordRepeated
      },
      false,
      true,
      true
    )
  }

  public getFeedbackTypes(loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/feedback-types?loggedInUsername='+loggedInUsername,
      false,
      true,
      null
    );
  }

  public createWishlistEntry(loggedInUsername: string, feedbackObj: any, impersonatedEmail?: string): any {
    let apiUrl: string = this.contextApi + '/protected/feedback/create?loggedInUsername='+loggedInUsername
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.postCall(
      apiUrl,
      feedbackObj,
      false,
      true
    );
  }

  public updateWishlistEntry(loggedInUsername: string, feedbackObj: any, impersonatedEmail?: string): any {
    let apiUrl: string = this.contextApi + '/protected/feedback/'+ feedbackObj.feedbackId +'/update?loggedInUsername='+loggedInUsername
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.putCall(
      apiUrl,
      feedbackObj,
      false,
      true
    );
  }

  public getAllWishlistEntriesByUser(loggedInUsername: string, page: number, pageSize: number, impersonatedEmail?: string): any {
    let apiUrl: string = this.contextApi + '/protected/feedback/read/all?loggedInUsername='+loggedInUsername;
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.getCall(
      apiUrl,
      false,
      true,
      {
        "pageOffset": page,
        "pageSize": pageSize},
      null,
      false,
      null
    );
  }

  public getAllWishlistEntries(loggedInUsername: string, feedbackTypeId: number, impersonatedEmail?: string): any {
    let apiUrl: string = this.contextApi + '/protected/feedback/read/feedback-type/' + feedbackTypeId + '/all?loggedInUsername=' + loggedInUsername;
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.getCall(
      apiUrl,
      false,
      true,
      null,
      null,
      false,
      null
    );
  }

  public getWishlistEntryDetails(loggedInUsername: string, feedbackId: number, impersonatedEmail?: string): any {
    let apiUrl: string = this.contextApi + '/protected/feedback/' + feedbackId + '/read?loggedInUsername=' + loggedInUsername;
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.getCall(
      apiUrl,
      false,
      true,
      null,
      null,
      false,
      null
    );
  }

  public getSubscriptionPricingV2(loggedInUsername: string) {
    return this.apiService.getCall(
      this.contextApi + '/protected/subscriptions/pricing/v2',
      false,
      true,
      {
        "loggedInUsername" : loggedInUsername
      },
      null,
      false,
      null
    );
  }

  public getSubscriptionPricingV3(loggedInUsername: string) {
    return this.apiService.getCall(
      this.contextApi + '/protected/subscriptions/pricing/v3',
      false,
      true,
      {
        "loggedInUsername" : loggedInUsername
      },
      null,
      false,
      null
    );
  }

  public getSubscriptionPricingV4(loggedInUsername: string) {
    return this.apiService.getCall(
      this.contextApi + '/protected/subscriptions/pricing/v4',
      false,
      true,
      {
        "loggedInUsername" : loggedInUsername
      },
      null,
      false,
      null
    );
  }

  public getSubscriptionPricingV4ByPlanName(subscriptionPlanName: string) {
    return this.apiService.getCall(
      this.contextApi + '/public/subscriptions/pricing/v4/subscription-plan-name',
      false,
      false,
      {
        "subscriptionPlanName" : subscriptionPlanName
      },
      null,
      false,
      null
    );
  }

  public getConsultantSubscriptionPricingV3(loggedInUsername: string) {
    return this.apiService.getCall(
      this.contextApi + '/public/subscriptions/pricing/v3/subscription-types/GRASSROOTS_SUBSCRIPTION_MONTHLY/monthly',
      false,
      true,
      {
        "loggedInUsername" : loggedInUsername
      },
      null,
      false,
      null
    );
  }


  public getSubscriptionPricingBySubscriptionTypeV3(subscriptionType: string) {
    return this.apiService.getCall(
      this.contextApi + '/public/subscriptions/pricing/v3/subscription-types/' + subscriptionType,
      false,
      true,
      {
        "subscriptionType": subscriptionType
      },
      null,
      false,
      null
    );
  }

  public getSubscriptionPricingBySubscriptionTypeV4(subscriptionType: string) {
    return this.apiService.getCall(
      this.contextApi + '/public/subscriptions/pricing/v4/subscription-types/' + subscriptionType,
      false,
      false,
      {
        "subscriptionType": subscriptionType
      },
      null,
      false,
      null
    );
  }

  public getConfig(configName: string) {
    return this.apiService.getCall(
      this.contextApi + '/public/config/read',
      false,
      true,
      {
        "configName": configName
      },
      null,
      false,
      null
    );
  }

  public getSubscriptionPricingV3Visionary() {
    return this.apiService.getCall(
      this.contextApi + '/public/subscriptions/pricing/v3/subscription-types/visionary',
      false,
      true,
      null,
      null,
      false,
      null
    );
  }

  public getSubscriptionPricingV3Trailblazer() {
    return this.apiService.getCall(
      this.contextApi + '/public/subscriptions/pricing/v3/subscription-types/visionary',
      false,
      true,
      null,
      null,
      false,
      null
    );
  }

  public getCausesDropdown(): any {
    return this.apiService.getCall(
      this.contextApi + '/public/dropdown/causes',
      false,
      true,
      null,
      null,
      false,
      null
    );
  }

  public checkoutSession(loggedInUsername: string, subscriptionPlanLengthMonths: number, promoCodeTxt: string): any {
    let checkoutParams: any =  {
      "loggedInUsername" : loggedInUsername,
      "subscriptionPlanLengthMonths": subscriptionPlanLengthMonths
    }
    if (promoCodeTxt) {
      checkoutParams["promoCodeTxt"] = promoCodeTxt
    }
    return this.apiService.getCall(
      this.contextApi + '/protected/subscriptions/checkout/v2',
      false,
      true,
      checkoutParams,
      null,
      false,
      null
    );
  }

  public checkoutSessionV3(loggedInUsername: string, subscriptionPlanName: string, promoCodeTxt: string): any {
    let checkoutParams: any =  {
      "loggedInUsername" : loggedInUsername,
      "subscriptionPlanName": subscriptionPlanName
    }
    if (promoCodeTxt) {
      checkoutParams["promoCodeTxt"] = promoCodeTxt
    }
    return this.apiService.getCall(
      this.contextApi + '/protected/subscriptions/checkout/v3',
      false,
      true,
      checkoutParams,
      null,
      false,
      null
    );
  }

  public checkoutSessionConsultantV3(loggedInUsername: string, subscriptionPlanLengthMonths: number, invitedByClientBeforeJoining?: string): any {
    let checkoutParams: any =  {
      "loggedInUsername" : loggedInUsername,
      "subscriptionPlanLengthMonths": subscriptionPlanLengthMonths
    }
    if (invitedByClientBeforeJoining) {
      checkoutParams["invitedByClientBeforeJoining"] = invitedByClientBeforeJoining;
    }
    return this.apiService.getCall(
      this.contextApi + '/public/subscriptions/checkout/consultants/v3',
      false,
      false,
      checkoutParams,
      null,
      false,
      null
    );
  }

  public checkoutSessionConsultantV3SavePaymentMethodOnApproval(loggedInUsername: string): any {
    let checkoutParams: any =  {
      "loggedInUsername" : loggedInUsername
    }
    return this.apiService.getCall(
      this.contextApi + '/public/subscriptions/checkout/consultants/v3',
      false,
      false,
      checkoutParams,
      null,
      false,
      null
    );
  }

  public checkoutSessionUpdatePaymentMethodV3(loggedInUsername: string): any {
    let checkoutParams: any =  {
      "loggedInUsername" : loggedInUsername
    }
    return this.apiService.getCall(
      this.contextApi + '/protected/subscriptions/checkout/save-payment-method/v3',
      false,
      true,
      checkoutParams,
      null,
      false,
      null
    );
  }

  public verifyConsultantReferralCodeWithActiveAccount(loggedInUsername: string, referralCode: string ): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/consultants/register/verify/referral-code/active/account',
      false,
      true,
      {
        "loggedInUsername" : loggedInUsername,
        "referralCode": referralCode
      },
      false
    );
  }
  public sendClientAnInvitationReminder(consultantEmail: string, clientEmail: string): any {
    return this.apiService.postCall(
      this.contextApi + '/public/consultants/send/client/invitation-reminder',
      {
        "consultantEmail" : consultantEmail,
        "clientEmail": clientEmail
      },
      false,
      false,
      true,
      false,
      null
    );
  }

  public setUserDefaultPayment(loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/public/subscriptions/set-default-payment-method',
      false,
      false,
      {
        "loggedInUsername" : loggedInUsername
      },
      false
    );
  }

  public changeSubscription(loggedInUsername: string, subscriptionPlanLengthMonths: number, promoCodeTxt: string): any {
    let checkoutParams: any =  {
      "loggedInUsername" : loggedInUsername,
      "subscriptionPlanLengthMonths": subscriptionPlanLengthMonths
    }
    if (promoCodeTxt) {
      checkoutParams["promoCodeTxt"] = promoCodeTxt
    }
    return this.apiService.getCall(
      this.contextApi + '/protected/subscriptions/change-subscription/v3',
      false,
      true,
      checkoutParams,
      null,
      false,
      null
    );
  }

  public getSubscriptionPricingWithPromoCode(loggedInUsername: string, promoCodeTxt: string) {
    return this.apiService.getCall(
      this.contextApi + '/protected/subscriptions/pricing',
      false,
      true,
      {
        "loggedInUsername" : loggedInUsername,
        "promoCodeTxt" : promoCodeTxt
      },
      null,
      false,
      null
    );
  }

  public getSubscriptionVerification(loggedInUsername: string, impersonatedEmail? : string | undefined): any {
    let apiUrl: string = this.contextApi + '/protected/subscriptions/verify/v2?loggedInUsername=' + loggedInUsername;
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.getCall(
      apiUrl,
      false,
      true,
      null,
      null,
      false,
      null
    );
  }

  public getMostRecentSubscription(loggedInUsername: string, impersonatedEmail? : string | undefined): any {
    let apiUrl: string = this.contextApi + '/protected/subscriptions/read-latest';
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.getCall(
      apiUrl,
      false,
      true,
      {"loggedInUsername": loggedInUsername},
      null,
      false
    );
  }

  public getPaymentHistory(filter: any, loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/payments/history?loggedInUsername='+loggedInUsername,
      false,
      false,
      {filter: filter},
      null,
      false
      );
  }

  public getInvoiceHistory(filter: any, loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/payments/invoices/history/v2?loggedInUsername='+loggedInUsername,
      false,
      true,
      {filter: filter},
      null,
      false
    );
  }

  public getMostRecentPayment(loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/payments/most-recent?loggedInUsername='+loggedInUsername,
      false,
      true,
      null,
      null,
      false
    );
  }

  public getMostRecentInvoice(loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/payments/invoices/most-recent/v2?loggedInUsername='+loggedInUsername,
      false,
      true,
      null,
      null,
      false
    );
  }

  public cancelSubscriptionRenewal(loggedInUsername: string): any {
    return this.apiService.postCall(
      this.contextApi + '/protected/subscriptions/cancel?loggedInUsername=' + loggedInUsername,
      false,
      false,
      true,
      true,
      false
    );
  }

  public getInvoiceForPDF(invoiceId: string,loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/payments/invoices/' + invoiceId + '/v2',
      false,
      true,
      {
        'loggedInUsername': loggedInUsername
      },
      null,
      false
    );
  }

  public getAllPaymentMethods(loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/payment-methods',
      false,
      true,
      {
        'loggedInUsername': loggedInUsername
      },
      null,
      false
    );
  }

  public getAllPaymentTypes(loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/payment-types',
      false,
      true,
      {
        'loggedInUsername': loggedInUsername
      },
      null,
      false
    );
  }

  public addNewFundingGoal(fundingGoalDto: FundingGoalDto, loggedInUsername: string, impersonatedEmail?: string): any {
    let apiUrl: string = this.contextApi + '/protected/manage-funding-goals/funding-goals/create?loggedInUsername='+loggedInUsername;
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.postCall(
      apiUrl,
      fundingGoalDto,
      false,
      true,
      true
    );
  }

  public editFundingGoal(fundingGoalDto: FundingGoalDto, loggedInUsername: string, impersonatedEmail?: string): any {
    let apiUrl: string = this.contextApi + '/protected/manage-funding-goals/funding-goals/' + fundingGoalDto.fundingGoalId + '/edit?loggedInUsername='+loggedInUsername;
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.putCall(
      apiUrl,
      fundingGoalDto,
      false,
      true,
      true
    );
  }

  public getFundingGoal(fundingGoalId: number, loggedInUsername: string, impersonatedEmail?: string): any {
    let apiUrl: string = this.contextApi + '/protected/manage-funding-goals/funding-goals/' + fundingGoalId + '/read?loggedInUsername='+loggedInUsername;
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.getCall(
      this.contextApi + '/protected/manage-funding-goals/funding-goals/' + fundingGoalId + '/read?loggedInUsername='+loggedInUsername,
      false,
      true,
      null,
      null
    );
  }

  public getAllFundingGoals(loggedInUsername: string, impersonatedEmail?: string): any {
    let apiUrl: string = this.contextApi + '/protected/manage-funding-goals/funding-goals/list?loggedInUsername='+loggedInUsername;
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.getCall(
      apiUrl,
      false,
      true,
      null,
      null
    );
  }

  public getAllFundingGoalsPages(page: number, pageSize: number, loggedInUsername: string, impersonatedEmail?: string): any {
    let apiUrl: string = this.contextApi + '/protected/manage-funding-goals/funding-goals/pages/list?loggedInUsername='+loggedInUsername;
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.getCall(
      apiUrl,
      false,
      true,
      {
        "page": page,
        "pageSize": pageSize
      },
      null
    );
  }

  public getAllFundingGoalSavedSearchMappingsByFundingGoalId(loggedInUsername: string, fundingGoalId: string,
                                                             impersonatedEmail?: string): any {
    let apiUrl: string = this.contextApi + '/protected/manage-funding-goals/' + fundingGoalId + '/saved-searches/read/all?loggedInUsername='+loggedInUsername
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.getCall(
      apiUrl,
      false,
      true,
      null,
      null
    );
  }

  public getAllFundingGoalSavedSearchMappingsBySavedSearchId(loggedInUsername: string, savedSearchId: string, impersonatedEmail?: string): any {
    let apiUrl: string = this.contextApi + '/protected/saved-searches/' + savedSearchId + '/funding-goals/read/all?loggedInUsername='+loggedInUsername
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.getCall(
      apiUrl,
      false,
      true,
      null,
      null
    );
  }

  public deleteFundingGoal(fundingGoalId: string, loggedInUsername: string, impersonatedEmail?: string) {
    let apiUrl: string = this.contextApi + '/protected/manage-funding-goals/funding-goals/'+ fundingGoalId +'/delete?loggedInUsername='+loggedInUsername
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.deleteCall(
      apiUrl,
      false,
      true,
      false,
      false
    );
  }

  public addNewSavedSearch(savedSearchDto: any, loggedInUsername: string, impersonatedEmail?: string): any {
    let apiUrl: string = this.contextApi + '/protected/saved-searches/create?loggedInUsername='+loggedInUsername;
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.postCall(
      apiUrl,
      savedSearchDto,
      false,
      true,
      true
    );
  }

  public editSavedSearch(savedSearchDto: any, loggedInUsername: string, impersonatedEmail?: string): any {
    let apiUrl: string = this.contextApi + '/protected/saved-searches/' + savedSearchDto.savedSearchId + '/update?loggedInUsername='+loggedInUsername;
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.putCall(
      apiUrl,
      savedSearchDto,
      false,
      true,
      true
    );
  }

  public getSavedSearch(savedSearchId: string, loggedInUsername: string, impersonatedEmail?: string): any {
    let apiUrl: string = this.contextApi + '/protected/saved-searches/' + savedSearchId + '/read?loggedInUsername='+loggedInUsername;
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.getCall(
      apiUrl,
      false,
      true,
      null,
      null
    );
  }

  public getAllSavedSearchesOverview(loggedInUsername: string, impersonatedEmail?: string): any {
    let apiUrl: string = this.contextApi + '/protected/saved-searches/read/all/overview?loggedInUsername='+loggedInUsername;
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.getCall(
      apiUrl,
      false,
      true,
      null,
      null
    );
  }
  public getAllSavedSearches(loggedInUsername: string, searchTypeName: string, impersonatedEmail?: string): any {
    let apiUrl: string = this.contextApi + '/protected/saved-searches/read/all?loggedInUsername='+loggedInUsername;
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.getCall(
      apiUrl,
      false,
      true,
      {
        "searchTypeName": searchTypeName
      },
      null
    );
  }

  public getAllSavedSearchesPages(loggedInUsername: string, searchTypeName: string, page: number,
                                  pageSize: number, impersonatedEmail?: string): any {
    let apiUrl: string = this.contextApi + '/protected/saved-searches/pages/read/all?loggedInUsername=' + loggedInUsername;
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.getCall(
      apiUrl,
      false,
      true,
      {
        "searchTypeName": searchTypeName,
        "page": page,
        "pageSize": pageSize
      },
      null
    );
  }

  public deleteSavedSearches(savedSearchId: string, loggedInUsername: string, impersonatedEmail?: string): any {
    let apiUrl: string = this.contextApi + '/protected/saved-searches/' + savedSearchId + '/delete?loggedInUsername='+loggedInUsername;
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.deleteCall(
      apiUrl,
      false,
      true,
      false,
      false
    );
  }

  public updateSavedSearchFundingGoalsMapping(fundingGoalId: string, loggedInUsername: string, mappings: any[],
                                              impersonatedEmail?: string): any {
    let apiUrl: string = this.contextApi + '/protected/manage-funding-goals/' + fundingGoalId + '/update/saved-searches/update?loggedInUsername='+loggedInUsername;
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.putCall(
      apiUrl,
      mappings,
      false,
      true,
      true
    );
  }

  public updateSavedSearchFundingGoalsMappingBySavedSearchId(savedSearchId: string, loggedInUsername: string,
                                                             mappings: any[], impersonatedEmail?: string): any {
    let apiUrl: string = this.contextApi + '/protected/saved-searches/' + savedSearchId + '/update/funding-goals/update?loggedInUsername='+loggedInUsername
    apiUrl = this.addImpersonatedEmailToApiUrl(apiUrl, impersonatedEmail);
    return this.apiService.putCall(
      apiUrl,
      mappings,
      false,
      true,
      true
    );
  }
  public getUSAStatesDropdown(): any {
    return this.apiService.getCall(
      this.contextApi + '/public/dropdown/states',
      false,
      false,
      null,
      null,
      false,
      null
    );
  }

  public getBlogs(username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/blogs',
      false,
      true,
      {
        loggedInUsername: username
      },
      null,
      false,
      null
    );
  }

  public getBlog(username: string, blogName: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/blogs/blog-name',
      false,
      true,
      {
        loggedInUsername: username,
        blogName: blogName
      },
      null,
      false,
      null
    );
  }

  public getGuides(username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/guides',
      false,
      true,
      {
        loggedInUsername: username
      },
      null,
      false,
      null
    );
  }

  public getGuide(username: string, guideName: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/guides/guide-name',
      false,
      true,
      {
        loggedInUsername: username,
        guideName: guideName
      },
      null,
      false,
      null
    );
  }

  public getTutorials(username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/tutorials',
      false,
      true,
      {
        loggedInUsername: username
      },
      null,
      false,
      null
    );
  }

  public getTutorial(username: string, tutorialName: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/tutorials/tutorial-name',
      false,
      true,
      {
        loggedInUsername: username,
        tutorialName: tutorialName
      },
      null,
      false,
      null
    );
  }

  public getVideo(username: string, videoName: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/videos',
      false,
      true,
      {
        loggedInUsername: username,
        videoName: videoName
      },
      null,
      false,
      null
    );
  }

  public getVideos(username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/videos',
      false,
      true,
      {
        loggedInUsername: username
      },
      null,
      false,
      null
    );
  }
}

